export default __webpack_public_path__ + "e6280f65c3dc548d73c540e43e5d33f2.woff";